import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PaymentHandlingComponent } from './core/payment-handling/payment-handling.component';

export const routes: Routes = [
    {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren:  () => import('./auth/account.routing').then(m => m.AccountRoutes),
      },

      {
        path: "error",
        loadChildren: () => import('./shared/components/error/error.routing').then(m => m.ErrorRoutes),
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/main.routes').then(m => m.routes),
  },
  {
    path: "payment-callback",
    component: PaymentHandlingComponent,
    title: "Payment Handling",
  },
  {
    path: "**",
    redirectTo: "error/404",
  },
];
